import moment from "moment";
import { DISTRIBUTOR_TAB } from "../../framework/tab/tabUtilsConstants";
import { calculationTypes } from "../../utils/constant";
export const columnDefs = [
  {
    headerName: "Id",
    field: "distributorId",
    width: 100,
    locked: false,
    hide: true,
    suppressMovable: true,
  },
  {
    headerName: "Distributor",
    field: "distributorName",
    locked: false,
    hide: false,
    width: 300,
  },
  {
    headerName: "Short Code",
    field: "srtCode",
    hide: false,
    width: 100,
  },
  {
    headerName: "Sales Email",
    field: "sendEmail",
    hide: false,
    width: 150,
  },
  {
    headerName: "Purchase Email",
    field: "email",
    hide: false,
    width: 150,
  },
  {
    headerName: "Contact",
    field: "contact",
    hide: false,
    width: 100,
  },
  {
    headerName: "Phone/Landline Number",
    field: "landlineNumber",
    width: 150,
  },
  {
    headerName: "DL No",
    field: "dlno",
    hide: false,
    width: 150,
  },
  {
    headerName: "License Valid Till",
    field: "licValidDate",
    hide: false,
    width: 150,
  },
  {
    headerName: "CST VAT No",
    field: "cstVat",
    hide: false,
    width: 150,
  },
  {
    headerName: "GST No",
    field: "distributorGstin",
    hide: false,
    width: 150,
  },
  {
    headerName: "MSME Registration No",
    field: "msmeRegNo",
    hide: false,
    width: 150,
  },
  {
    headerName: "GST Type",
    field: "gstType",
    hide: false,
    width: 150,
  },
  {
    headerName: "State Code",
    field: "gstState",
    hide: false,
    width: 150,
  },
  {
    headerName: "Address",
    field: "address",
    hide: false,
    width: 200,
  },
  {
    headerName: "Building Name",
    field: "buildingName",
    hide: false,
    width: 200,
  },
  {
    headerName: "Locality",
    field: "locality",
    hide: false,
    width: 200,
  },
  {
    headerName: "Landmark",
    field: "landmark",
    hide: false,
    width: 200,
  },
  {
    headerName: "Pincode",
    field: "pincode",
    hide: false,
    width: 200,
  },
  {
    headerName: "City",
    field: "city",
    hide: false,
    width: 200,
  },
  {
    headerName: "Area",
    field: "area",
    hide: false,
    width: 200,
  },
  {
    headerName: "Region",
    field: "region",
    hide: false,
    width: 200,
  },
  {
    headerName: "Zone",
    field: "zone",
    hide: false,
    width: 200,
  },
  {
    headerName: "Country",
    field: "country",
    hide: false,
    width: 200,
  },
  {
    headerName: "Lat/Long",
    field: "latLong",
    hide: false,
    width: 200,
  },
  {
    headerName: "GST State",
    field: "gstState",
    hide: false,
    width: 100,
  },
  {
    headerName: "Bank Name",
    field: "bankName",
    hide: false,
    width: 100,
  },
  {
    headerName: "Account Number",
    field: "accountNumber",
    hide: false,
    width: 100,
  },
  { headerName: "IFSC", field: "ifsc", width: 150, hide: false },
  { headerName: "MICR", field: "micrCode", width: 150, hide: false },
  {
    headerName: "Transaction Type",
    field: "openingTransactionType",
    width: 150,
    hide: false,
  },
  {
    headerName: "PAN/TAN",
    field: "panTan",
    width: 150,
    hide: false,
  },
  {
    headerName: "Credit Period",
    field: "creditPeriod",
    width: 150,
    hide: false,
  },
  {
    headerName: "Distributor Sales Person",
    field: "distributorSalesPerson",
    width: 150,
    hide: false,
  },
  {
    headerName: "Distributor Sales Mobile",
    field: "distributorSalesMobile",
    width: 150,
    hide: false,
  },
  {
    headerName: "Calculation Type",
    field: "calculationType",
    width: 150,
    hide: false,
  },
  {
    headerName: "Due Date Type",
    field: "dueDateType",
    width: 150,
    hide: false,
  },
  {
    headerName: "Distributor Type",
    field: "distributorType",
    width: 150,
    hide: false,
  },
  {
    headerName: "Credit Days",
    field: "creditDays",
    width: 150,
    hide: false,
  },
  {
    headerName: "Updated Date",
    field: "updatedTime",
    hide: false,
    width: 180,
  },
];
const getCalculationTypeLabel = (id) => {
  const calculationType = calculationTypes.find((type) => type.id === id);
  return calculationType ? calculationType.label : id;
};
export const columnDefsFunctions = {
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  calculationType: {
    valueFormatter: (params) => {
      return getCalculationTypeLabel(params.value);
    },
  },
  licValidDate: {
    valueFormatter: (params) => {
      return params.value ? moment(`${params.value}`).format("DD/MM/YYYY") : "";
    },
  },
};

export const initial_state_distributor = {
  type: DISTRIBUTOR_TAB,
  label: "Distributors",
  allowMultipleTabs: false,
};
